<div
	class="p-5 border-b flex flex-1 justify-between border-grey-lightest w-full"
>
	<div class="flex-1">
		<p class="text-3xl font-bold">Mortgage intake</p>
		<p class="text-grey">Use your mortgage instructions to sync with Closer.</p>

		<ng-container *ngIf="(selectedMortgage | keyvalue)?.[0]?.value as lender">
			<div *ngIf="showConnectSyncBanner">
				<div
					class="p-4 pb-8 my-2 z-0 rounded-t-lg bg-tealGreen-50 border-tealGreen-100"
				>
					<div class="flex justify-between mb-4">
						<div class="flex gap-2 items-center">
							<div class="flex justify-center items-center">
								<i-tabler
									class="h-4 w-4 text-tealGreen-500"
									name="info-square-rounded"
								></i-tabler>
							</div>
							<h3 class="h3">Connect to Sync!</h3>
						</div>
						<ui-button
							[color]="'gray'"
							[style]="'ghost'"
							icon="x"
							size="sm"
							(click)="dismissConnectPromotion()"
						/>
					</div>
					<div>
						<p class="p-sm">
							Join Sync to easily upload
							{{ lender?.shortName || lender?.displayName || lender?.name }}
							instructions into Closer and automatically populate mortgage
							details into your file.
						</p>
						<div
							class="flex gap-2 mt-4 items-center cursor-pointer p-sm"
							(click)="goToCloserSync()"
						>
							<span class="text-tealGreen-500 hover:underline duration-300"
								>Get started with Sync ></span
							>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="showUseSyncBanner">
				<div
					class="p-4 pb-8 my-1 z-0 rounded-t-lg bg-orange-50 border-orange-100"
				>
					<div class="flex justify-between mb-4">
						<div class="flex gap-2 items-center">
							<div class="flex justify-center items-center">
								<i-tabler
									class="h-4 w-4 text-orange-500"
									name="alert-triangle"
								></i-tabler>
							</div>
							<h3 class="h3">Save time with Sync!</h3>
						</div>
						<ui-button
							[style]="'ghost'"
							[color]="'gray'"
							icon="x"
							size="sm"
							(click)="dismissInboxPromotion()"
						/>
					</div>
					<div>
						<p class="p-sm">
							Upload
							{{ lender?.shortName || lender?.displayName || lender?.name }}
							instructions through Sync to automatically populate mortgage
							details into your file.
						</p>
						<div
							class="flex gap-2 mt-4 items-center cursor-pointer p-sm"
							(click)="goToInbox()"
						>
							<span class="text-orange-dark hover:underline duration-300"
								>Go to Mortgage Inbox to upload lender instructions ></span
							>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
	<div
		*ngIf="selectedMortgage?.source === matterMortgageInstructionSource.ASSYST"
	>
		<a
			class="flex items-center gap-2 text-green-600 hover:underline cursor-pointer"
			externalNavInterceptor
			href="https://unity.doprocess.com/login/home"
			target="_blank"
		>
			<img
				class="max-w-[100px]"
				src="assets/images/integrations/assyst-logo.svg"
			/>
			<div class="flex items-center gap-2">
				<div class="whitespace-nowrap">Open</div>
				<app-icon [icon]="ICON.EXTERNAL"></app-icon>
			</div>
		</a>
	</div>
</div>
<div class="grid h-full w-full min-h-0 px-8 pt-5 grid-rows-1 grid-cols-2">
	<div class="overflow-y-auto">
		<h4 class="font-bold">Intake fields</h4>
		<app-mortgage-intake-fields [selectedMortgage]="selectedMortgage" />
	</div>

	<div class="overflow-y-auto flex justify-center items-start pl-2">
		<div class="w-full h-full flex flex-1" *ngIf="(latestDoc$ | async)?.url">
			<app-multiple-url-pdf-viewer
				class="h-full w-full"
				*ngIf="(latestDoc$ | async)?.url"
				[matterDocumentType]="mortgageDocumentType"
				[contextId]="selectedMortgage?.id"
			></app-multiple-url-pdf-viewer>
		</div>
		<app-container
			type="dark"
			class="w-full flex flex-1 px-1 pb-1 pt-4"
			*ngIf="!(latestDoc$ | async)?.url"
		>
			<div class="w-full h-fit flex justify-center items-start">
				<app-sale-file-upload
					type="modal"
					class="w-full h-fit"
					label="Upload mortgage documents"
					[saleId]="matterId"
					[contextId]="selectedMortgage?.id"
					[documentType]="mortgageDocumentType"
				></app-sale-file-upload>
			</div>
		</app-container>
	</div>
</div>
<footer
	class="flex flex-1 justify-between items-center py-5 px-5 z-50 bg-grey-lightest"
>
	<div class="flex ml-12">
		<ui-button
			[style]="'outline'"
			(click)="onBack()"
			label="Cancel"
		></ui-button>
	</div>
	<div class="flex mr-12">
		<ui-button label="Continue" (click)="continue()"></ui-button>
	</div>
</footer>
